import { gql } from '@apollo/client';

export const GENERATE_POST_DESCRIPTION = gql`
  mutation GeneratePostDescription(
    $userInput: String!
    $projectContext: ProjectContextInput
  ) {
    generatePostDescription(
      userInput: $userInput
      projectContext: $projectContext
    ) {
      descriptionId
      description
    }
  }
`;
